import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators }from 'redux';
import ProfileActionsSection from './ProfileActionsSection';
import { addProfile, resetProfile, updateProfile, resetProfileEditionMode } from 'redux/profiles/ProfilesActions';

const mapStateToProps = state => ({
  profile: state.profiles.profile,
  mappingInfo: state.mappingFile.mappingInfo
});

const mapDispatchToActions = dispatch => ({
  profileActions: bindActionCreators({ addProfile, resetProfile, updateProfile, resetProfileEditionMode }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToActions)(ProfileActionsSection));



// WEBPACK FOOTER //
// ./src/components/importProfile/comp/profileActionsSection/ProfileActionsSectionConnector.js